
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://sahcnyqjfmcqrasnmwzc.supabase.co";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNhaGNueXFqZm1jcXJhc25td3pjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUxMzAyMTcsImV4cCI6MjA1MDcwNjIxN30.iy_c3pdcauf9rGbZAJF7JzMofzUtaOTsPxDJJwj8lZI";

export const supabase = createClient<Database>(
  supabaseUrl, 
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: localStorage,
      storageKey: 'lovable-auth-token',
      flowType: 'implicit'
    },
    db: {
      schema: 'public'
    }
  }
);

// Ajouter un listener pour les changements d'état d'authentification
supabase.auth.onAuthStateChange((event, session) => {
  console.log('État d\'authentification changé:', event, session);
  if (event === 'SIGNED_OUT') {
    // Nettoyer les données en cache lors de la déconnexion
    localStorage.removeItem('lovable-auth-token');
  }
});
